import { Loader } from '@paysense-india-services/elevate-web'

const LandingPage = () => <Loader color='brand' loadingText='Loading...' pageLoader size='large' />

export default LandingPage
